var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"game__border",class:[
    _vm.winner === 'tie'
      ? 'tie'
      : _vm.winner === 'red'
      ? 'red'
      : _vm.winner === 'blue'
      ? 'blue'
      : _vm.turn.allegiance,
    _vm.turn.role === _vm.player.role ? 'active' : '',
    _vm.winner ? 'active' : ''
  ]})
}
var staticRenderFns = []

export { render, staticRenderFns }